import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

export const useThankYouPageLoading = (): boolean => {
    const {
        isLoading: isTranslationsLoading,
        isFetching: isTranslationsFetching,
    } = useStringTranslation();
    const { isLoading: isUserLoading } = useGetUserInfoQuery();

    return isTranslationsLoading || isTranslationsFetching || isUserLoading;
};
